/**
 * permissions.js
 * Centralizador de controle de acesso baseado em cargos (RBAC) do sistema Entertainment-Maintenance.
 */

// Superadministrador de sistema / Dev com acesso irrestrito
export const SUPER_ADMIN_ID = 'bed8024a-a18d-4b3a-a071-aa2c588afb9d';

export function isSuperAdmin(user) {
  return !!user && user.id === SUPER_ADMIN_ID;
}

// Hierarquia numérica de cargos (quanto maior, maior a autoridade)
export const ROLES_HIERARCHY = {
  operador: 1,
  tecnico_estagiario: 2,
  tecnico_pleno: 4,
  technician: 4, // legado
  tecnico_senior: 5,
  gestor: 6,     // Gerente: acima do Técnico Sênior, abaixo do Proprietário
  proprietario: 7,
  owner: 7,      // legado
  admin: 8,
  master: 8      // legado
};

// Lista de identificadores de cargos autorizados como "Técnico Sênior para cima"
export const SENIOR_AND_ABOVE_ROLES = [
  'tecnico_senior',
  'tecnico senior',
  'técnico sênior',
  'senior',
  'sênior',
  'proprietario',
  'proprietário',
  'owner',
  'gestor',
  'admin',
  'administrator',
  'master'
];

/**
 * Verifica se o usuário atual possui cargo de Técnico Sênior ou superior
 * (Técnico Sênior, Proprietário, Administrador ou Desenvolvedor).
 *
 * @param {Object} user - Objeto de usuário do Supabase Auth
 * @param {Array<string>} userRoles - Array de roles atribuídos no location_permissions
 * @returns {boolean}
 */
export function isSeniorOrAbove(user, userRoles = []) {
  if (!user) return false;

  if (isSuperAdmin(user)) return true;

  const userCargo = (
    user.app_metadata?.role ||
    ''
  ).toLowerCase();

  // Verifica metadata do usuário
  if (SENIOR_AND_ABOVE_ROLES.some((c) => userCargo.includes(c))) return true;

  // Verifica roles vindos da tabela location_permissions
  if (
    Array.isArray(userRoles) &&
    userRoles.some((r) =>
      SENIOR_AND_ABOVE_ROLES.some((c) => (r || '').toLowerCase().includes(c))
    )
  ) {
    return true;
  }

  return false;
}
